import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Home.css';
import "../index.css"

import hero_image from "../images/components/Hero/homepage_hero.webp";
import how_it_works_image from "../images/pages/home/how_it_works.webp"
import about1 from "../images/pages/home/about1.webp";
import about2 from "../images/pages/home/about2.webp";

import HeroTextAndImage from "../components/universal/HeroTextAndImage/HeroTextAndImage.js";
import FeaturedLogos from "../components/universal/FeaturedLogos/FeaturedLogos.js";
import NewsletterFooter from "../components/universal/NewsletterFooter/NewsletterFooter.js";
import BlogCardSwiper from "../components/pages/resources/BlogCardSwiper/BlogCardSwiper.js";
import SponsorAndPartnerLogos from "../components/universal/SponsorAndPartnerLogos/SponsorAndPartnerLogos.js";

import the_economist_logo from "../images/pages/home/The Economist Light Teal Logo.svg";
import netflix_logo from "../images/pages/home/Netflix Light Teal Logo.svg";
import canva_logo from "../images/pages/home/Canva Light Teal Logo.svg";
import gds_logo from "../images/pages/home/Government Digital Service Light Teal Logo.svg";

function App() {
	return (
		<div>

			<Helmet>
				<title>Mission Encodeable | Free coding tutorials for young people</title>
				<meta name="description" content="Mission Encodeable offers free project-based, creative and engaging coding tutorials for young people across the world." />
			</Helmet>

			<HeroTextAndImage
				titleText="The <em>coolest</em> way to learn to code"
				subtitleText="Free project-based, creative and engaging coding tutorials for young people."
				buttons={[
        			{ text: "Get started", link: "/get-started", style: "btn_orange_fill" },
        			{ text: "Info for teachers", link: "/teachers", style: "btn_orange_outline" }
    			]}
				heroImage={hero_image}
				heroImageAlt="A mockup of the Mission Encodeable coding tutorials on a Macbook and iPhone"
			/>

			<SponsorAndPartnerLogos />

			<section className='about'>
				<div className='about_block'>
					<h3 className='text white'>Our mission is to inspire future computer scientists</h3>
					<Link to="/about"><button className='btn_green_text btn_orange_fill'>About us</button></Link>
				</div>
			</section>

			<section className='how_it_works'>

				<div className='how_it_works_image_wrapper'>
					<img src={how_it_works_image} alt="An abstract illustration of the Mission Encodeable coding tutorials on a laptop" />
				</div>

				
				<div className="text">
					<h6 className="mini-section-heading">How it works</h6>
					<h2 className='darkgreen'>Free coding <u>tutorials</u></h2>

					<div className="how-it-works-step">
						<div className="step-text">
							<h5>Choose a level</h5>
							<p>Our courses are broken into a series of simple and well-explained levels. Before you begin, choose which level is most appropriate for you, or, if you're a beginner, start at Level 1.</p>
						</div>
					</div>


					<div className="how-it-works-step">
						<div className="step-text">
							<h5>Learn to make projects</h5>
							<p>In each level, we'll teach you the core programming fundamentals, and walk you through a number of projects, so you can put what you've learnt into practice.</p>
						</div>
					</div>

					<div className="how-it-works-step">
						<div className="step-text">
							<h5>Get your certificate</h5>
							<p>After you've completed the independent capstone project at the end of the level, you'll recieve a personalised certificate.</p>
						</div>
					</div>


					<br />

					<Link to="/get-started"><button className="btn_green_outline">Get started</button></Link>

				</div>
			</section>

			<section className="featured-in">
				<p className="mini-section-heading">Why trust us?</p>
				<h3 className="featured-heading-white">We've been <u>featured</u> by industry experts & press</h3>
				<FeaturedLogos />
			</section>

			<section className="about-photos-block">
				<div className="about-left">
					<div className="about-text">
						<p className="mini-section-heading">About us</p>
						<h3>We're on a mission to inspire future computer scientists</h3>
						<p className="darkgreen">As a student-led initiative, we're creating free, creative tutorials that make coding accessible to students everywhere.</p>
						<Link to="/about"><button className='btn_green_outline'>About us</button></Link>
					</div>
					<img src={about1} alt="Harry and Anna Wake, the founders of Mission Encodeable, sat at a table on their laptops, with a plant in the foreground" loading="lazy" />
				</div>
				<div className="about-right">
					<img src={about2} alt="Harry and Anna Wake, the founders of Mission Encodeable, in front of a colourful Thierry Noir wall graffiti artwork" loading="lazy" />
				</div>
			</section>

			<div className="info-for-teachers">
					<p className="mini-section-heading mini-section-heading-centred">TEACHER RESOURCES</p>
					<h3 className="darkgreen">If you'd like to use Mission Encodeable with your students, then take a look at our teacher resources.</h3>
					<Link to="/teachers"><button className='btn_green_outline'>Info for teachers</button></Link>
			</div>

			<div className="homepage-bottom-bg">

				<div className="podcast-promo">
					<p className="mini-section-heading mini-section-heading-centred">PODCAST</p>
					<h3 className="darkgreen">Get a behind-the-scenes look at exciting roles in the tech industry</h3>
					<div className="podcast-company-logos">
						<div className="podcast-company-logo-container">
							<Link to="/podcast/faria-anzum"><img src={canva_logo} alt="Canva logo" /></Link>
						</div>
						<div className="podcast-company-logo-container">
							<Link to="/podcast/leanne-cummings"><img src={gds_logo} alt="Government Digital Service logo" /></Link>
						</div>
						<div className="podcast-company-logo-container">
							<Link to="/podcast/david-leen"><img src={netflix_logo} alt="Netflix logo" /></Link>
						</div>
						<div className="podcast-company-logo-container">
							<Link to="/podcast/alex-selby-boothroyd"><img src={the_economist_logo} alt="The Economist logo" /></Link>
						</div>
					</div>
					<p className="darkgreen">The Inside Tech Careers podcast features inspiring guests who share what their jobs involve, what a typical day looks like, and the advice they'd offer to anyone interested in pursuing a similar path.</p>
					<Link to="/podcast"><button className='btn_green_outline'>See the episodes</button></Link>
				</div>

				<hr className="block-seperator-green" />

				<section className="home-resources">
					<p className="mini-section-heading mini-section-heading-centred">Blog</p>
					<h3 className="resources-section-intro"><u>Discover the latest</u> blog posts from the Mission Encodeable team</h3>

					<section className='home-blog-posts' id="blog-posts">
						<BlogCardSwiper />
					</section>

				</section>

			</div>

			<NewsletterFooter />

		</div>
	)
}

export default App;
